var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdc661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68661"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M0,98.275,98.275,0H368.533A24.569,24.569,0,0,1,393.1,24.569V368.533A24.569,24.569,0,0,1,368.533,393.1H24.569A24.569,24.569,0,0,1,0,368.533Z",
    fill: "url(#linear-gradient4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M98.275,0V73.707A24.569,24.569,0,0,1,73.707,98.275H0Z",
    fill: "url(#linear-gradient4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-98.536-27.516V0h-19.1V-82.321h29.041a47.891,47.891,0,0,1,14.944,2.062A28.679,28.679,0,0,1-63.365-74.58,22.138,22.138,0,0,1-57.4-66.049a28.926,28.926,0,0,1,1.921,10.622,31.231,31.231,0,0,1-1.977,11.3,22.676,22.676,0,0,1-6.046,8.814,28.489,28.489,0,0,1-10.311,5.735,47.263,47.263,0,0,1-14.775,2.062Zm0-14.408h9.944q7.458,0,10.735-3.559t3.277-9.944a14.872,14.872,0,0,0-.847-5.141A10.463,10.463,0,0,0-78-64.551a11.558,11.558,0,0,0-4.35-2.571,19.243,19.243,0,0,0-6.243-.9h-9.944Zm68.478-40.4a16.208,16.208,0,0,1,2.09.113,5.336,5.336,0,0,1,1.526.424,5.091,5.091,0,0,1,1.3.876,14.851,14.851,0,0,1,1.413,1.525l39.1,49.438q-.226-2.373-.339-4.6t-.113-4.209V-82.321H31.753V0H21.809A9.163,9.163,0,0,1,18.08-.678a7.979,7.979,0,0,1-2.938-2.486L-23.674-52.206q.169,2.147.282,4.209t.113,3.87V0H-40.115V-82.321ZM89.5-13.786a32.494,32.494,0,0,0,7.006-.678,34.3,34.3,0,0,0,5.763-1.808V-28.759H94.129a3.951,3.951,0,0,1-2.825-.961,3.2,3.2,0,0,1-1.017-2.429V-42.658h29.267V-7.91a43.131,43.131,0,0,1-6.582,3.983,42.518,42.518,0,0,1-7.288,2.74A54.265,54.265,0,0,1,97.434.4,81.731,81.731,0,0,1,88.027.9,43.161,43.161,0,0,1,71.3-2.288,40.641,40.641,0,0,1,58-11.1a40.568,40.568,0,0,1-8.814-13.334,43.371,43.371,0,0,1-3.192-16.752A45.607,45.607,0,0,1,49.042-58.11a38.113,38.113,0,0,1,8.729-13.306,39.6,39.6,0,0,1,13.729-8.7,49.628,49.628,0,0,1,18-3.107,52.412,52.412,0,0,1,9.661.847,47.534,47.534,0,0,1,8.334,2.317,38.353,38.353,0,0,1,6.978,3.5,37.584,37.584,0,0,1,5.65,4.407l-5.537,8.419a6.15,6.15,0,0,1-1.893,1.865,4.5,4.5,0,0,1-2.4.678,6.615,6.615,0,0,1-3.5-1.13q-2.26-1.356-4.266-2.345a26.029,26.029,0,0,0-4.1-1.61,26.846,26.846,0,0,0-4.407-.9,43.247,43.247,0,0,0-5.2-.283,23.712,23.712,0,0,0-9.661,1.893,20.715,20.715,0,0,0-7.317,5.339,24.149,24.149,0,0,0-4.661,8.277A33.364,33.364,0,0,0,65.54-41.189a34.643,34.643,0,0,0,1.808,11.639,25.006,25.006,0,0,0,5,8.588,21.231,21.231,0,0,0,7.571,5.339A24.517,24.517,0,0,0,89.5-13.786Z",
    transform: "translate(191.592 230.405)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/png_icon.df8636fa984189b380cd69e0168fa399.svg";
export { ForwardRef as ReactComponent };